import React, { useState, useEffect, useRef } from 'react'
import HelpIcon from '@mui/icons-material/Help';


interface Props {
    tooltipText: string
    position: string
}

const MobileClickToolTip: React.FC<Props> = ({ tooltipText, position }) => {
    const tooltipRef = useRef(null)
    const [styling, setStyling] = useState({})
    const [showTooltip, setShowTooltip] = useState<boolean>(false)
    useEffect(() => {
        if (position === 'left') {
            setStyling({ left: "-10px" })
        } else if (position === 'right') {
            setStyling({ right: "-10px" })
        }
    }, [])

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
                setShowTooltip(false)
            }
        } 
        if (showTooltip) {
            document.addEventListener('mousedown', handleClickOutside)
        }
        return (): void => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [showTooltip])


    return (<div style={{ position: "relative" }} onClick={(): void => setShowTooltip(!showTooltip)} ref={tooltipRef }>
        <HelpIcon fontSize="small"/>
        {showTooltip && <div>
            <div style={{ ...styling, position: "absolute", bottom: "50px", width: "250px", background: "gray", color: "white", padding: "10px 10px 0 10px", borderRadius: "3px" }}>
                <p style={{ textAlign: "center" }}>{tooltipText}</p>
            </div>
            <div style={{ position: "absolute", background: "gray", width: "20px", height: "20px", transform: "rotate(-45deg)", bottom: "40px" }}></div>
        </div>}
    </div>)
}
export default MobileClickToolTip